import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { eraseLotDataFromStore } from '../../../store/actions/negotiationLot/negotiationLotActions';
import Dialog from '@material-ui/core/Dialog';
import NegotiationLotSummary from './NegotiationLotSummary';


class NegotiationLotEditForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  handleClose() {
    this.props.openEditLotMainForm();
    this.props.eraseLotDataFromStore();
    this.props.reloadNegotiationLotsTableList();
  };


  render() {

    return (
      <Dialog
        fullScreen
        open={this.props.open}
        onClose={this.handleClose.bind(this)}
      >
        <NegotiationLotSummary
          handleClose={this.handleClose.bind(this)}
          showContent={this.props.showContent}
          reloadTable={() => this.props.reloadNegotiationLotsTableList()}
        />
      </Dialog>
    );
  }
}

NegotiationLotEditForm.propTypes = {
  openEditLotMainForm: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => ({
  eraseLotDataFromStore: () => dispatch(eraseLotDataFromStore())
});

export default connect(mapStateToProps, mapDispatchToProps)(NegotiationLotEditForm);


// WEBPACK FOOTER //
// ./src/components/Negotiation/EditLots/NegotiationLotEditForm.js